import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { WorkNotification } from '../models/work-notification.model';
import { PagedRequest } from '../models/requests/paged-request';

@Injectable({
  providedIn: 'root',
})
export class WorkNotificationService {
  constructor(private apiService: ApiService) {}

  public getPaged(
    request: PagedRequest
  ): Observable<{ Items: WorkNotification[]; TotalRecords: number }> {
    return this.apiService.post<{ Items: WorkNotification[]; TotalRecords: number }>(
      `/WorkNotification/WorkNotification/GetWorkNotificationsForSanitization`,
      request
    );
  }
}
